import { MPARequestListPerspective, MPARequestStatus } from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';
import { useDAL } from '@/contexts/useDAL';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
const BADGE_SWR_OPTIONS: SWRConfiguration = {
  refreshInterval: 60_000,
  revalidateOnFocus: true
};
export const useMpaRequestsCounts = () => {
  const {
    ActionApprovals
  } = useFeatureFlags();
  const dal = useDAL();
  const {
    data: policiesBody,
    isLoading: isPoliciesLoading
  } = dal.mpa.policies.useList(undefined);
  const hasPolicies = (policiesBody?.policies?.length ?? 0) > 0;
  const countsEnabled = !!ActionApprovals && hasPolicies;
  const {
    data: requests,
    isLoading: isRequestsLoading,
    mutate: mutateRequests
  } = dal.mpa.requests.useList({
    filters: {
      status: MPARequestStatus.MPA_REQUEST_STATUS_PENDING_APPROVAL,
      perspective: MPARequestListPerspective.MPA_REQUEST_LIST_PERSPECTIVE_REVIEWER,
      excludeReviewed: true
    }
  }, undefined, 1, BADGE_SWR_OPTIONS, countsEnabled);
  const {
    data: myRequests,
    isLoading: isMyRequestsLoading,
    mutate: mutateMyRequests
  } = dal.mpa.myRequests.useList({
    filters: {
      status: MPARequestStatus.MPA_REQUEST_STATUS_APPROVED
    }
  }, undefined, 1, BADGE_SWR_OPTIONS, countsEnabled);
  const refresh = async () => {
    await Promise.all([mutateRequests(), mutateMyRequests()]);
  };
  return {
    requests,
    myRequests,
    isLoading: isPoliciesLoading || isRequestsLoading || isMyRequestsLoading,
    shouldShowCounts: countsEnabled,
    refresh
  };
};